import { connect } from 'react-redux'
import processYieldForm from '../ui/forms/processYieldForm'
import { setProcessYieldValues } from '../../store/actions/processYieldActions'

const mapStateToProps = state => ({
    processYieldValues: state.formulas.processYield
})

const mapDispatchToProps = dispatch => {
    return {
        formToState: (val) => {
            dispatch(
                setProcessYieldValues(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(processYieldForm)